import { Serializable } from '@admin/core/models/serializable';

export class ProviderWebsiteLanguageModel
  implements Serializable<ProviderWebsiteLanguageModel>
{
  fromObject(object: any): ProviderWebsiteLanguageModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    throw new Error('Not Implemented');
  }

  public primaryLanguageCode: string;
  public primaryLanguageName: string;
  public alternativeLanguageCode: string;
  public alternativeLanguageName: string;
}
